import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { StatusOperacional } from '../../models/status-operacional.model';
import { NavigationService } from '../../services/navigation.service';
import { StatusOperacionalService } from '../../services/status-operacional.servives';

@Component({
  selector: 'app-status-operacional-list',
  templateUrl: './status-operacional-list.component.html',
  styleUrls: ['./status-operacional-list.component.scss'],
})
export class StatusOperacionalListComponent extends BaseListComponent<StatusOperacional> implements OnInit, OnDestroy {

  statusList: StatusOperacional[];

  constructor(
    private myService: StatusOperacionalService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.statusList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/projetos/admin-spgg/status-operacionais/adicionar'];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: any): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message)
      },
    });
  }

  editar(id: number) {
    return ['/projetos/admin-spgg/status-operacionais/', id];
  }
}
